<div class="force-change-password">
  <img
    class="back-arrow"
    src="{{assetsRoute}}/picture/new-back-arrow-m.png"
    alt=""
    (click)="hide()"
  />

  <div class="pwd-header">
    <p class="pwd-header__title">修改登录密码</p>
    <p class="pwd-header__subtitle">为了保障您的账号安全，请修改登录密码后再继续使用</p>
  </div>

  <div class="pwd-form">
    <div class="pwd-field">
      <label class="pwd-field__label">当前密码</label>
      <div class="pwd-field__box" [class.is-error]="!!errors.oldPassword">
        <input
          [type]="oldPwdVisible ? 'text' : 'password'"
          placeholder="请输入当前密码"
          autocomplete="current-password"
          maxlength="200"
          class="pwd-field__input"
          [(ngModel)]="form.oldPassword"
          (blur)="handleFormBlur(); validateOldPassword()"
          name="oldPassword"
          required
        />
        <span class="pwd-field__toggle" (click)="oldPwdVisible = !oldPwdVisible">
          <img
            class="pwd-field__icon"
            [src]="oldPwdVisible ? assetsRoute + '/picture/show-pwd.png' : assetsRoute + '/picture/hide-pwd.png'"
            alt=""
          />
        </span>
      </div>
      <div class="pwd-field__error" *ngIf="errors.oldPassword">{{ errors.oldPassword }}</div>
    </div>

    <div class="pwd-field">
      <label class="pwd-field__label">新密码</label>
      <div class="pwd-field__box" [class.is-error]="!!errors.newPassword">
        <input
          [type]="newPwdVisible ? 'text' : 'password'"
          placeholder="请输入新密码"
          autocomplete="new-password"
          maxlength="200"
          class="pwd-field__input"
          [(ngModel)]="form.newPassword"
          (input)="onNewPasswordInput()"
          (blur)="handleFormBlur(); validateNewPassword()"
          name="newPassword"
          required
        />
        <span class="pwd-field__toggle" (click)="newPwdVisible = !newPwdVisible">
          <img
            class="pwd-field__icon"
            [src]="newPwdVisible ? assetsRoute + '/picture/show-pwd.png' : assetsRoute + '/picture/hide-pwd.png'"
            alt=""
          />
        </span>
      </div>
      <p class="pwd-field__hint" *ngIf="!errors.newPassword">
        请输入8位以上密码，且至少包含大写字母、小写字母、数字、特殊字符中的三类
      </p>
      <div class="pwd-field__error" *ngIf="errors.newPassword">{{ errors.newPassword }}</div>
    </div>

    <div class="pwd-field">
      <label class="pwd-field__label">确认新密码</label>
      <div class="pwd-field__box" [class.is-error]="!!errors.confirmPassword">
        <input
          [type]="confirmPwdVisible ? 'text' : 'password'"
          placeholder="请再次输入新密码"
          autocomplete="new-password"
          maxlength="200"
          class="pwd-field__input"
          [(ngModel)]="form.confirmPassword"
          (input)="onConfirmPasswordInput()"
          (blur)="handleFormBlur(); validateConfirmPassword()"
          name="confirmPassword"
          required
        />
        <span class="pwd-field__toggle" (click)="confirmPwdVisible = !confirmPwdVisible">
          <img
            class="pwd-field__icon"
            [src]="confirmPwdVisible ? assetsRoute + '/picture/show-pwd.png' : assetsRoute + '/picture/hide-pwd.png'"
            alt=""
          />
        </span>
      </div>
      <div class="pwd-field__error" *ngIf="errors.confirmPassword">{{ errors.confirmPassword }}</div>
    </div>

    <button
      class="pwd-submit"
      type="button"
      [disabled]="!canSubmit"
      (click)="submit()"
    >
      <span class="pwd-submit__text">确认修改</span>
      <i *ngIf="submitting" class="fa fa-spinner pwd-submit__spinner"></i>
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/force-change-password/force-change-password.component.html